export default function getFileExtension(fileName) {
  if (fileName === 'Youtube Video') return 'video';
  const parts = fileName?.split('.');
  if (!parts) return;
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}
